export default __webpack_public_path__ + "static/media/trash.46539a0e.svg";